import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Spinner,
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
} from "react-bootstrap";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import "./StateNegotations.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const TrendGraphs = ({ fondo }) => {
  const [selectedTab, setSelectedTab] = useState("1d");
  const [chartType, setChartType] = useState("unitPrice"); // Valor de Unidad por defecto
  const [chartData, setChartData] = useState({
    labels: [],
    returns: [],
    unitPrice: [],
  });
  const [loading, setLoading] = useState(true);

  const handleTabChange = (key) => setSelectedTab(key);
  const handleChartType = (type) => setChartType(type);

  // Genera datos falsos
  const generateFakeData = (points) => {
    const labels = [];
    const returns = [];
    const unitPrice = [];
    let date = new Date();

    for (let i = 0; i < points; i++) {
      date.setDate(date.getDate() - 1);
      labels.unshift(
        date.toLocaleDateString("es-CO", { month: "short", day: "numeric" })
      );
      returns.unshift((Math.random() * 10 - 5).toFixed(2));
      unitPrice.unshift((100 + Math.random() * 50).toFixed(2));
    }
    return { labels, returns, unitPrice };
  };

  // Data falsa con claves correctas
  const dataFalsa = {
    "1d": generateFakeData(5),
    "1m": generateFakeData(40),
    "3m": generateFakeData(15),
    "6m": generateFakeData(20),
    "1a": generateFakeData(30),
    "5a": generateFakeData(50),
    "10a": generateFakeData(100),
  };

  // Carga datos al cambiar tab
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setChartData(dataFalsa[selectedTab]);
      setLoading(false);
    }, 500);
  }, [selectedTab]);

  // Configuración de Chart.js
  const values = chartData[chartType] || [];
  const labels = chartData.labels || [];
  const lastY = values.length ? parseFloat(values[values.length - 1]) : 0;
  const minValue = values.length ? Math.min(...values) - 1 : 0;
  const maxValue = values.length ? Math.max(...values) + 1 : 100;

  const data = {
    labels,
    datasets: [
      {
        label: chartType === "returns" ? "Rendimientos (%)" : "Valor de Unidad",
        data: values,
        borderColor: "#2a3eb1",
        borderWidth: 2,
        fill: false,
        pointBackgroundColor: (_, i) =>
          i === values.length - 1 ? "red" : "transparent",
        pointRadius: (_, i) => (i === values.length - 1 ? 5 : 0),
        tension: 0.3,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: { legend: { display: false } },
    scales: {
      y: { min: minValue, max: maxValue },
      x: { ticks: { maxRotation: 45, minRotation: 45 } },
    },
  };

  return (
    <Container>
      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Row className="mt-4">
          <Col md={2} className="mb-3 text-center">
            <ButtonGroup className="custom-buttons">
              <Button
                className={`custom-btn ${
                  chartType === "unitPrice" ? "active" : ""
                }`}
                onClick={() => handleChartType("unitPrice")}
              >
                Valor de Unidad
              </Button>
              <Button
                className={`custom-btn ${
                  chartType === "returns" ? "active" : ""
                }`}
                onClick={() => handleChartType("returns")}
              >
                Rendimientos
              </Button>
            </ButtonGroup>
          </Col>
          <Col md={10} className="state-negotations-tabs">
            <Tabs
              activeKey={selectedTab}
              onSelect={handleTabChange}
              className="mb-3 justify-content-center"
            >
              <Tab eventKey="1d" title="1D" />
              <Tab eventKey="1m" title="1M" />
              <Tab eventKey="3m" title="3M" />
              <Tab eventKey="6m" title="6M" />
              <Tab eventKey="1a" title="1A" />
              <Tab eventKey="5a" title="5A" />
              <Tab eventKey="10a" title="10A" />
            </Tabs>

            <Line data={data} options={options} />
            <div className="text-end mt-2">
              <strong>Último valor: {lastY}</strong>
            </div>
          </Col>
        </Row>
      )}
    </Container>
  );
};
